import { j as r } from "./jsx-runtime-DmTjM30f.mjs";
import { forwardRef as D, useMemo as c, cloneElement as f } from "react";
import { c as n } from "./tw-cn-mXgPecoF.mjs";
import { e as E } from "./extract-responsive-property-BiJ5BiwI.mjs";
import { D as K } from "./dot-badge-C98VgBNP.mjs";
import { r as w, a as M } from "./rectangle-button.styles-CcWb17YW.mjs";
const _ = D(
  ({
    theme: u = "filled_primary",
    disabled: g = !1,
    fullWidth: S = !1,
    isCapsule: b = !1,
    showDotBadge: i = !1,
    loading: p = !1,
    size: x,
    weight: y = "bold",
    direction: s = "left",
    ...z
  }, N) => {
    const { children: v, type: R = "button", icon: e, iconVisualCorrectionSpacing: t, className: h, ...j } = z, a = E({
      property: x,
      mobileKey: "size",
      pcKey: "pcSize",
      defaultValue: { mobile: "medium", pc: "large" }
    }), I = w({ fullWidth: S, ...a, theme: u, weight: y, isCapsule: b }), l = M({ ...a, direction: s }), o = g || p, P = c(() => e && s === "left" ? f(e, { className: n(l, e.props.className) }) : null, [e, s, l]), V = c(() => e && s === "right" ? f(e, { className: n(l, e.props.className) }) : null, [e, s, l]), $ = c(() => {
      if (!t) return;
      const B = a.size === "small" ? 8 : 16, m = t + B, C = a.pcSize === "small" ? 8 : 16, d = t + C;
      return s === "left" ? `pr-${m} pc:pr-${d}` : `pl-${m} pc:pl-${d}`;
    }, [s, t, a.size, a.pcSize]);
    return /* @__PURE__ */ r.jsxs(
      "button",
      {
        "aria-disabled": o || void 0,
        className: n(I, $, h),
        "data-state": p ? "loading" : void 0,
        disabled: o,
        ref: N,
        tabIndex: o ? -1 : 0,
        type: R,
        ...j,
        children: [
          P,
          /* @__PURE__ */ r.jsxs("span", { className: n("relative flex", !i && "overflow-hidden"), children: [
            v,
            !!i && !o && /* @__PURE__ */ r.jsx(K, {})
          ] }),
          V
        ]
      }
    );
  }
);
_.displayName = "NDS.RectangleButton";
export {
  _ as R
};
